import { render, staticRenderFns } from "./SofAddTemplate.vue?vue&type=template&id=37f6c3eb&scoped=true&"
import script from "./SofAddTemplate.vue?vue&type=script&lang=js&"
export * from "./SofAddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SofAddTemplate.vue?vue&type=style&index=0&id=37f6c3eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6c3eb",
  null
  
)

export default component.exports